import React, { FC, memo } from 'react';

import { format, parseISO } from 'date-fns';

import { ReactComponent as EyeSvg } from 'assets/svg/eye.svg';
import { DAY_FORMAT_WITH_SLASHES } from 'constants/dateFormats';
import { ButtonVariants } from 'constants/shared/button';
import { LeadData } from 'interfaces/leads.interfaces';
import { Button } from 'shared-components';
import { TableData, TableRow } from 'shared-components/table';

type Props = {
  lead: LeadData;
  handleOpenModal: () => void;
};

const LeadsTableItem: FC<Props> = memo(function LeadsTableItem({ lead, handleOpenModal }) {
  const { id, firstName, lastName, email, phoneNumber, created_at, reasonForInterest } = lead;
  return (
    <TableRow key={id}>
      <TableData>{id}</TableData>
      <TableData>{`${firstName} ${lastName}`}</TableData>
      <TableData>{email}</TableData>
      <TableData>{phoneNumber}</TableData>
      <TableData>{created_at ? format(parseISO(created_at), DAY_FORMAT_WITH_SLASHES) : ''}</TableData>
      <TableData className='max-w-[200px]'>{reasonForInterest}</TableData>
      <TableData>
        <Button
          variant={ButtonVariants.TRANSPARENT}
          className='w-[50px] h-full float-right'
          onClick={() => {
            handleOpenModal();
          }}
        >
          <EyeSvg className='fill-blue-800' />
        </Button>
      </TableData>
    </TableRow>
  );
});
LeadsTableItem.displayName = 'LeadsTableItem';

export default LeadsTableItem;
